import { LogService } from '@servicetitan/log-service';
import { useCallback, useState } from 'react';
import { CustomerAuthRenderer } from './CustomerAuthRenderer';
import { CustomerAuthChallengeStatus } from '@servicetitan/financing-api-client';

type Step = 'request' | 'verification' | 'success';

interface CustomerAuthContainerProps {
    onCompleted: () => void;
    onBack?: () => void;
}

export const CustomerAuthContainer = ({ onCompleted, onBack }: CustomerAuthContainerProps) => {
    const [currentStep, setCurrentStep] = useState<Step>('request');

    const [challengeStatus, setChallengeStatus] = useState<CustomerAuthChallengeStatus | null>(
        null,
    );

    const handleBack = useCallback(() => {
        if (currentStep === 'request' && onBack) {
            onBack();
        } else {
            setCurrentStep('request');
        }
    }, [onBack, currentStep]);

    const handleSubmitVerification = useCallback(() => {
        setCurrentStep('success');
        onCompleted();
    }, [onCompleted]);

    const handleRequestSuccess = useCallback((challengeData: CustomerAuthChallengeStatus) => {
        setChallengeStatus(challengeData);
        setCurrentStep('verification');
    }, []);

    return (
        <LogService endpoint="/api/log" storageKey="LogStorage_CustomerAuthFlow">
            <CustomerAuthRenderer
                currentStep={currentStep}
                challengeStatus={challengeStatus}
                onBack={onBack ? handleBack : undefined}
                onSubmitVerification={handleSubmitVerification}
                onRequestSuccess={handleRequestSuccess}
                onChallengeStatusUpdate={setChallengeStatus}
            />
        </LogService>
    );
};
